import { combineReducers } from "redux";

import homebanner from "../features/admin/homepage/homebanner/Slice";

import everyspace from "../features/admin/homepage/everyspace/Slice";

import common from "../features/admin/common/Slice";

const homepage = combineReducers({
    homebanner,
    everyspace,
    common
});

export default homepage;